<template>
  <div class="">
    <div>
      <v-card class="neu-glow">
        <v-card-title>
          Ritaglia Immagine
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :loading="loading_update" :disabled="!cropImg" @click.stop.prevent="submit">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" @click.prevent="cropImage">
                <v-icon color="info">mdi-crop</v-icon>
              </v-btn>
            </template>
            <span>Ritaglia</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" @click.prevent="showFileChooser">
                <v-icon color="info">mdi-image-search</v-icon>
              </v-btn>
            </template>
            <span>Scegli Immagine</span>
          </v-tooltip>                    
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" @click.stop.prevent="cancel()">
                <v-icon color="info">mdi-close-circle</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>          
        </v-card-title>
        <v-card-text> 
          <v-card class="neu-glow pa-4">
            <input
              ref="input"
              type="file"
              name="image"
              accept="image/*"
              @change="setImage"
            />
            <div class="content">
              <v-row>
                <v-col cols="8">
                  <v-card class="neu-glow pa-4">
                    <vue-cropper
                      v-if="uploadFormData"
                      ref="cropper"
                      :aspect-ratio="aspectRatio"
                      :autoCropArea="1"
                      :viewMode="viewMode"
                      format="jpg"
                      :src="imgSrc"
                      @crop="crp(e)"
                      preview=".preview"
                      style="min-height:400px;"
                    />
                  </v-card>
                </v-col>
                <v-col cols="4" v-if="uploadFormData.width">
                  <v-card class="neu-glow pa-4">
                    <div class="mb-2">Preview:  {{dataP?dataP.width.toFixed(0)+' x '+ dataP.height.toFixed(0)+' pixels':''}}</div>
                    <div class="preview" />
                    <p class="mt-2 mb-0" v-if="dataP&&dataP.width < uploadFormData.width ">Si consiglia di non scendere sotto i {{uploadFormData.width}}px di larghezza per non perdere di risoluzione</p>
                    <p class="mt-2 mb-0" v-if="dataP&&dataP.width> (uploadFormData.width)">l'immagine viene comunque ridimensionata a {{uploadFormData.width +' x ' +(uploadFormData.width/aspectRatio)+' pixels' }}</p>
                  </v-card>
                  
                  <v-card class="neu-glow pa-4 mt-3">
                    <div class="mb-2">Immagine Ritagliata: {{dataC?uploadFormData.width + ' x '+ (uploadFormData.width/aspectRatio)+' pixels':''}}</div>
                    <div class="cropped-image">
                      <img
                        v-if="cropImg"
                        :src="cropImg"
                        alt="Cropped Image"
                      />
                      <div v-else class="crop-placeholder" />
                    </div>
                  </v-card>
                 
                </v-col>
                <v-col cols="12">
                <v-card class="neu-glow pa-4 mt-3">
                  <v-row class="justify-space-between px-1">
                    <v-btn
                      class="ma-1"
                      color="info"
                      @click.prevent="zoom(0.05)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-magnify-plus</v-icon>
                      Zoom +
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="zoom(-0.05)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-magnify-minus</v-icon>
                      Zoom -
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="move(-1, 0)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-arrow-left-thick</v-icon>
                      DX
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="move(1, 0)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-arrow-right-thick</v-icon>
                      SX
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="move(0, -1)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-arrow-up-thick</v-icon>
                      SU
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="move(0, 1)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-arrow-down-thick</v-icon>
                      GIU
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="rotate(1)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-rotate-right-variant</v-icon>
                      Ruota DX
                    </v-btn>
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="rotate(-1)"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-rotate-left-variant</v-icon>
                      Ruota SX
                    </v-btn>
                    <a
                      class="ma-1 v-btn"                                          
                      ref="flipX"
                      @click.prevent="flipX"
                    >
                      <v-btn color="info">
                        <v-icon right class="ml-0 mr-2">mdi-flip-horizontal</v-icon>
                        Flip X
                      </v-btn>
                    </a>
                    <a
                      class="ma-1 btn"
                      ref="flipY"
                      @click.prevent="flipY"
                    >
                      <v-btn color="info">
                        <v-icon right class="ml-0 mr-2">mdi-flip-vertical</v-icon>
                        Flip Y
                      </v-btn>
                    </a>
                    <!--
                    <v-btn
                      class="ma-1"
                      color="info"                    
                      @click.prevent="viewModeInc()"
                    >
                      <v-icon right class="ml-0 mr-2">mdi-aspect-ratio</v-icon>
                      VM: {{viewMode}}
                    </v-btn>
                    -->
                    <v-btn-toggle v-model="aspectRatio" active-class="info" style="width:100%" class="background">
                      <div style="width:100%" class="d-flex justify-space-between">
                        <v-btn
                          v-for="(a,ai) in aspectRatios"
                          :key="ai"
                          class="mx-1"
                          :value="a.value"
                        >
                        {{a.text}}
                        </v-btn>
                      </div>  
                    </v-btn-toggle>
                  </v-row>
                </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card>    
        </v-card-text> 
      </v-card>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
//https://www.npmjs.com/package/vue-cropperjs/v/4.2.0
//https://github.com/fengyuanchen/cropperjs
//https://github.com/Agontuk/vue-cropperjs/tree/master
export default {
  components: {
    VueCropper
  },
  props:{
    uploadFormData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      page: "Account",
      cropper: undefined,
      dataUrl: undefined,
      filename: undefined,
      subdomain:undefined,
      //imgSrc: 'https://ibookrestaurant.com/static/users/pictures/'+this.uploadFormData.type+'/'+this.uploadFormData.name,
      //uploadUrl:'https://ibookrestaurant.com/ajax/settings/upload.php',
      imgSrc: '/static/users/pictures/'+this.uploadFormData.type+'/'+this.uploadFormData.name,
      uploadUrl:'/ajax/settings/upload.php',      
      cropImg: '', 
      data:null,
      dataP:null,
      dataC:null,
      viewMode:1,
      aspectRatio:16/9,
      trigger:'#pick-wa_logo',
      mimes:'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
      aspectRatios:[{"text":"4:1","value":4},{"text":"3:1","value":3},{"text":"2:1","value":2},{"text":"16:9","value":16/9},{"text":"4:3","value":4/3},{"text":"1:1","value":1},{"text":"Free","value":NaN}]
    }
  },
  watch : {
    aspectRatio:function (newVal,oldVal)
    {
      console.log(247,newVal,oldVal)
      //this.$refs.cropper.destroy();
      //this.$refs.cropper;
      this.$refs.cropper.setAspectRatio(newVal)
    }
  },
  methods: {
    viewModeInc()
    {
      this.viewMode=this.viewMode>2?0:this.viewMode+1     
    },
    crp(e)
    {
      console.log(214,e);
      this.dataP=this.$refs.cropper.getData();
      console.log(215,this.dataP)
    },
  cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.getDataCropped()
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);

    },
    getDataCropped() {
      this.dataC = this.$refs.cropper.getData();
      console.log(243,this.dataC)
    },    
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
      this.getData();
    },
    reset() {
      console.log(259,'reset')
      this.uploadFormData=null;
      this.imgSrc=null;
      this.$refs.cropper.reset();
      //this.cropImg=null;
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;

      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;

      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      console.log(271,file)
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    pickImage(e) {
      this.$refs.input.click()
      e.preventDefault()
      e.stopPropagation()
    },    
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
      this.getData();
    },
    destroy() {
      console.log(311,'destroy')
      this.imgSrc=null;
      this.uploadFormData=null;
      this.$refs.input.value = ''
      this.dataUrl = undefined
      this.$refs.cropper.destroy()      
    },
    submit() {
      this.$emit('submit')
      if (this.uploadUrl) {
        this.uploadImage()
      } else if (this.uploadHandler) {
        this.uploadHandler(this.$refs.cropper)
      } else {
        this.$emit('error', 'No upload handler found.', 'user')
      }
      //this.destroy()
    },
    cancel(){
        this.$emit('close')
        //this.destroy();
    },
    uploadImage() {
      let imgW=this.uploadFormData.width;
      let imgH=this.uploadFormData.height;
      this.loading_update=true;
      console.log(327,imgW,imgH)
      this.$refs.cropper.getCroppedCanvas({width:imgW,height:imgH}).toBlob(
        blob => {
          let form = new FormData()
          let xhr = new XMLHttpRequest()
          //this.uploadFormData={name:'test',type:'wa','optionId':'pota'};
          let data = Object.assign({}, this.uploadFormData)
          console.log(297,data);
          xhr.withCredentials = false;//this.withCredentials;
          
          for (let key in data) {
            form.append(key, data[key])
          }
          console.log(317,this.uploadFormData)
          this.filename=this.uploadFormData.name;
          this.subdomain=this.uploadFormData.subdomain;
          this.iReviewWATemplateId=this.uploadFormData.iReviewWATemplateId;
          form.append('file', blob, this.filename,this.subdomain,this.iReviewWATemplateId)
          this.$emit('uploading', {form, xhr})

          xhr.open('POST', this.uploadUrl, true)
          
          let uploadHeaders={Authorization: sessionStorage.getItem("jwt")}

          for (let header in uploadHeaders) {
            console.log(311,uploadHeaders,header,uploadHeaders[header])
            xhr.setRequestHeader(header, uploadHeaders[header])
          }
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
              let response = ''
              try {
                response = JSON.parse(xhr.responseText)
              } catch (err) {
                response = xhr.responseText
              }
              var form1=this.uploadFormData;
              console.log(323,response,this.uploadFormData);
              this.$emit('completed', { response,form1 })
              this.loading_update=false;
              
              if (response.Status=='OK') {
                this.$emit('uploaded', { form, form1 })
                //this.$store.dispatch("setAvatar", response.Payload);
              } else {
                this.$emit('error', 'Image upload fail.', 'upload', xhr)
              }
              /*
              if ([200, 201, 204].indexOf(xhr.status) > -1) {
                this.$emit('uploaded', response, form, xhr)
                 this.$store.dispatch("setAvatar", '');
              } else {
                this.$emit('error', 'Image upload fail.', 'upload', xhr)
              }
              */
            }
          }
          console.log(349,form);
          xhr.send(form)
        },
        'image/png',
        this.outputQuality
      )
    }
  },
  mounted() {
    //let fileInput=this.uploadFormData.name;
    //this.pictureNameRoot=fileInput.split('.')[0];
    /*
    
    let trigger =
      typeof this.trigger == 'object'
        ? this.trigger
        : document.querySelector(this.trigger)
        console.log(266,trigger);
    if (!trigger) {
      this.$emit('error', 'No trigger found.', 'user')
    } else {
      trigger.addEventListener('click', this.pickImage)
    }

    //this.imgSrc='https://ibookrestaurant.com/static/users/pictures/wa/'+this.uploadFormData.name;
  
 
    // listen for input file changes
    let fileInput = this.$refs.input
    console.log(274,fileInput);
    fileInput.addEventListener('change', () => {
      if (fileInput.files != null && fileInput.files[0] != null) {
        let correctType = this.mimes.split(', ').find(m => m === fileInput.files[0].type);
        if (!correctType) {
          this.$emit('error', 'File type not correct.', 'user');
          return;
        }
        let reader = new FileReader()
        reader.onload = e => {
          this.dataUrl = e.target.result
        }

        reader.readAsDataURL(fileInput.files[0])

        this.filename = fileInput.files[0].name || 'unknown'
        this.mimeType = this.mimeType || fileInput.files[0].type
        this.$emit('changed', fileInput.files[0], reader)
      }
    })
    */
    
  }
}
</script>

<style scoped>

input[type="file"] {
  display: none;
}
.cropper-container{
 min-width: 650px;
 min-height: 410px;
 background-repeat: repeat!important;  
}
.cropper-bg{
 background-repeat: repeat!important; 
 background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
.content {
  display: flex;
  justify-content: space-between;
}
.preview {
  width: 100%;
  height: calc(420px * (10 / 16));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: 200px;
  background-repeat: repeat; 
  background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
}
.cropped-image img {
  max-width: 100%;
}
</style>